import type { ReactNode } from 'react';
import { Badge, Button, Divider, Group, Paper, Stack, TextInput } from '@mantine/core';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { ErrorAlert } from '@/components/error-alert';

type CrmIntegrationCardProps = {
  typeLabel: string;
  name: string;
  onNameChange: (name: string) => void;
  error: string | null;
  isSaving: boolean;
  isRemoving: boolean;
  canSave: boolean;
  onSave: () => void;
  onRemove: () => void;
  children: ReactNode;
};

export function CrmIntegrationCard({
  typeLabel,
  name,
  onNameChange,
  error,
  isSaving,
  isRemoving,
  canSave,
  onSave,
  onRemove,
  children,
}: CrmIntegrationCardProps) {
  return (
    <Paper p="md" withBorder radius="md">
      <Stack gap="md">
        <ErrorAlert message={error} />
        <Group align="flex-end">
          <TextInput
            label="Integration Name"
            value={name}
            onChange={(e) => onNameChange(e.currentTarget.value)}
            style={{ flex: 1 }}
          />
          <Badge variant="light" size="lg">
            {typeLabel}
          </Badge>
        </Group>

        {children}

        <Divider />

        <Group justify="space-between">
          <Button variant="subtle" color="red" onClick={onRemove} loading={isRemoving}>
            Remove Integration
          </Button>
          <Button
            leftSection={<IconDeviceFloppy size={16} />}
            onClick={onSave}
            loading={isSaving}
            disabled={!name.trim() || !canSave}
          >
            Save CRM Settings
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
}
